import { getAction, deleteAction, putAction, postAction, httpAction } from '@/comm/manage'
import Vue from 'vue'
import { UI_CACHE_DB_DICT_DATA } from "@/comm/mutation-types"
import { axios } from '@/comm/request'
import { MessageBox } from 'element-ui'
import router from '../router'
import store from './store'

/**
 * 用户登录系统
 */
export function login(parameter) {
    return new Promise((resolve, reject) => {
        postAction("/thepoly/login", parameter).then((res) => {
            if (res.success) {
                loginOperation(res);
                resolve(res);
            } else {
                reject(res);
            }
        });
    })
}

/**
 * 用户扫描二维码登录
 */
 export function queryUserIsLogin(parameter) {
    return new Promise((resolve, reject) => {
        postAction("/weChat/queryUserIsLogin", parameter).then((res) => {
            if (res.success) {
                loginOperation(res);
                resolve(res);
            } else {
                reject(res);
            }
        });
    })
}

export function loginOperation(res) {
    let timeout = parseInt(new Date().getTime() / 1000) + 604800; //七天后的日期
    var userExpire = {};
    if (res.result && res.result.userInfo) {
        userExpire.expire = timeout;
        Vue.ls.set("Login_Expire", userExpire);
        Vue.ls.set("Access_rain-Token", res.result.token, 60 * 60 * 1000 * 24 * 7);
        Vue.ls.set("UserInfo", res.result.userInfo);
    }
}



/**
 * 获取微信公众号二维码
 */
 export function getUUID() {
    return new Promise((resolve, reject) => {
        getAction("/weChat/getUUID").then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        });
    })
}

/**
 * 获取微信公众号二维码
 */
 export function getQrcode(parameter) {
    return new Promise((resolve, reject) => {
        getAction("/weChat/getQrcode", parameter).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        });
    })
}